/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { CurrentEmployeeService } from 'lib';
import { ICardSession, IForgotPasswordVerifyToken, IIdentity } from 'types';
import { IAppState } from '../types';
import { App } from './types';

const currentEmployee = CurrentEmployeeService.get();
const initialState: IAppState | null = currentEmployee ? { currentEmployee } : null;

export const appReducer: Reducer<IAppState | null> = (state = initialState, action) => {
  switch (action.type) {
    case App.SET_CURRENT_EMPLOYEE_SUCCESS: {
      if (!action.payload) return null; // Clear store when payload is not provided
      return {
        ...state,
        currentEmployee: action.payload,
      };
    }
    case App.FORGOT_PASSWORD_VERIFY_REQUEST: {
      return {
        ...state,
        forgotPasswordVerifyToken: undefined,
      };
    }
    case App.FORGOT_PASSWORD_VERIFY_SUCCESS: {
      return {
        ...state,
        forgotPasswordVerifyToken: action.payload as IForgotPasswordVerifyToken,
      };
    }
    case App.SET_TIP_CALCULATOR_FORM_DIRTY: {
      return {
        ...state,
        isTipCalcFormDirty: action.payload.isDirty,
      };
    }
    case App.GET_CARD_SESSION_SUCCESS: {
      return {
        ...state,
        cardSession: action.payload as ICardSession,
      };
    }
    case App.DESTROY_CARD_SESSION:
      return {
        ...state,
        cardSession: null,
      };
    case App.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotPasswordIdentity: action.payload as IIdentity,
      };
    case App.LOGOUT_SUCCESS:
      return null;
    default: {
      return state;
    }
  }
};
